/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
$(function() {
  var create = false;
  if (!($('#redesign-comments').length > 0)) { return; }

  var show = function show() {
    $('[data-reply]').show();
    $('[data-overflow-comments]').show();
    $('[data-more-comments]').hide();
    return create = true;
  };

  var bindShowMore = function bindShowMore() {
    $('[data-more-comments]').not('.click-bound').click(function(e) {
      return show();
    });
    return $('[data-more-comments]').addClass('click-bound');
  };

  bindShowMore();

  if (!($('[data-comment-modal]').length > 0)) { return; }

  var bindCreateComment = function bindCreateComment() {
    $('[data-create-comment]').click(function(e) {
      $('[data-create-comment]').hide();
      $('[data-comment-modal]').show();

      $("form#new_comment")[0].reset();
      var comment_form = $('#new_comment');
      comment_form.find('input[name=comment]').remove();
      comment_form.find('input[name=_method]').remove();
      comment_form[0].action = $('[data-create-path]').data('create-path');
      $('input#comment_base').prop('value', 'Submit comment');
      return create = true;
    });

    return $('[data-comment-modal-close]').click(function(e) {
        $('[data-comment-modal]').hide();
        return $('[data-create-comment]').show();
    });
  };

  var bindEditComment = function bindEditComment(elm) {
    $(elm).find('[data-update-path]').first().parent().show();
    return $(elm).find('[data-update-path]').first().click(function(e) {
      $('[data-comment-modal]').show();

      $('[name="comment[title]"]').val(
        $(elm).closest('[data-comment-title]').data('comment-title')
      );
      $('[name="comment[body]"]').val(
        $(elm).closest('[data-comment-body]').data('comment-body')
      );

      var comment_form = $('#new_comment');
      var crud_method = document.createElement('input');
      crud_method.type="hidden";
      crud_method.name="_method";
      crud_method.value="put";

      comment_form[0].action = $(this).data('update-path');
      comment_form.append(crud_method);

      setMetaInfo(this);

      return $('input#comment_base').prop('value', 'Update comment');
    });
  };

  var bindDeleteComment = function bindDeleteComment(elm) {
    $(elm).find('[data-delete-path]').first().parent().show();
    $(elm).find('[data-delete-path]').first().unbind('click');
    return $(elm).find('[data-delete-path]').first().click(function(e) {
      if (!confirm('Are you sure?')) {
        e.preventDefault();
        return;
      } else {
        var crud_method = document.createElement('input');
        crud_method.type="hidden";
        crud_method.name="_method";
        crud_method.value="delete";

        var comment_form = $('#new_comment');
        comment_form[0].action = $(this).data('delete-path');
        comment_form.append(crud_method);

        setMetaInfo(this);

        $('#new_comment').submit();
        return;
      }
    });
  };

  var bindReplyComment = function bindReplyComment() {
    return $('[data-reply-path]').click(function(e) {
      $('[data-comment-modal]').show();

      var comment_form = $('#new_comment');
      comment_form[0].action = $('[data-reply-path]').data('reply-path');

      setMetaInfo(this);

      create = true;

      return $('input#comment_base').prop('value', 'Submit comment');
    });
  };

  var bindPersonalControls = function bindPersonalControls() {
    if (!($('[data-current-member]').length > 0)) { return; }
    if (!($('[data-author]').length > 0)) { return; }
    var current = $('[data-current-member]').data('current-member');
    return $('[data-author]').not('.control-bound').each(function(i, elm) {
      $(elm).addClass('control-bound');
      if ($(elm).data('author') === current) {
        bindEditComment(elm);
        return bindDeleteComment(elm);
      }
    });
  };

  var setMetaInfo = function setMetaInfo(elm) {
    var meta_info = document.createElement('input');
    meta_info.type = "hidden";
    meta_info.name = "comment[comment_id]";
    meta_info.value = $(elm).data('comment-id');
    var comment_form = $('#new_comment');
    return comment_form.append(meta_info);
  };

  var bindSubmit = function bindSubmit() {
    return $('#new_comment').bind('ajax:complete', function(e) {
      $('[data-comment-modal]').hide();
      return $.reload('#redesign-comments', function() {
        return $('html').trigger('consumer:comments:refreshed');
      }, new Date().getTime());
    });
  };

  bindCreateComment();
  bindPersonalControls();
  bindSubmit();
  bindReplyComment();
  $('[data-more-comments]').show();

  return $('html').on('consumer:comments:refreshed', function() {
    bindCreateComment();
    bindPersonalControls();
    bindSubmit();
    bindReplyComment();
    bindShowMore();
    if (create) {
      return show();
    }
  });
});
